import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import __merge from 'lodash/merge';
import { useMemo } from 'react';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);
Tooltip.positioners.centerSegment = function (items) {
    if (!items.length) return false;
    const item = items[0];
    const element = item.element;
    const centerX = (element.x + element.base) / 2;
    const centerY = element.y;
    return {
        x: centerX,
        y: centerY + 8
    };
};

const GraficBarraHoritzontal = ({
    chartRef = null,
    options = {},
    datasets = [],
    maxValue = 100,
    lineVertical = 0,
    paddingTop = 24
}) => {
    const data = {
        labels: [''],
        datasets
    };

    const font = "'Bw 3cat', Helvetica, Arial, sans-serif";

    const baseOptions = useMemo(
        () => ({
            indexAxis: 'y',
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 0
            },
            layout: {
                padding: {
                    top: paddingTop
                }
            },
            interaction: {
                mode: 'nearest',
                intersect: true,
                axis: 'y'
            },
            plugins: {
                legend: { display: false },
                tooltip: {
                    filter: function (tooltipItem) {
                        return tooltipItem.dataset.label !== 'disabled';
                    },
                    backgroundColor: '#21292C',
                    titleColor: '#FFF',
                    bodyColor: '#FFF',
                    borderWidth: 0,
                    position: 'centerSegment',
                    yAlign: 'bottom',
                    xAlign: 'center',
                    animation: {
                        duration: 0
                    },
                    cornerRadius: 8,
                    usePointStyle: true,
                    boxWidth: 8,
                    boxHeight: 8,
                    footerMarginTop: 10,
                    footerSpacing: 6,
                    titleFont: {
                        family: font,
                        size: 14,
                        style: 'normal',
                        weight: 'normal'
                    },
                    bodyFont: {
                        family: '',
                        size: 14,
                        style: 'normal',
                        weight: 'normal'
                    },
                    footerFont: {
                        family: font,
                        size: 10,
                        style: 'normal',
                        weight: '500'
                    },
                    enabled: function (context) {
                        const chart = context.chart;
                        const active = chart.getActiveElements();
                        if (!active.length) return false;
                        const { datasetIndex } = active[0];
                        const dataset = chart.data.datasets[datasetIndex];
                        return dataset.label !== 'disabled';
                    },
                    callbacks: {
                        title: () => '',
                        label: (context) => {
                            return ` ${context.dataset.label}`;
                        },
                        footer: (context) => {
                            return ` ${context?.[0]?.formattedValue} escons`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    stacked: true,
                    min: 0,
                    max: maxValue,
                    display: false
                },
                y: {
                    stacked: true,
                    display: false
                }
            }
        }),
        [maxValue]
    );

    const optionsChart = useMemo(() => {
        return __merge({}, baseOptions, options);
    }, [baseOptions, options]);

    const verticalLinePlugin = {
        id: 'verticalLine',
        afterUpdate(chart) {
            chart.draw();
        },
        afterDraw(chart) {
            if (!lineVertical) return;
            const { ctx, chartArea, scales } = chart;
            const { top, bottom } = chartArea;

            const xScale = scales.x;
            const xPos = xScale.getPixelForValue(lineVertical);

            ctx.save();

            ctx.beginPath();
            ctx.setLineDash([4, 4]);
            ctx.strokeStyle = '#000';
            ctx.lineWidth = 1;

            ctx.moveTo(xPos, top);
            ctx.lineTo(xPos, bottom);

            ctx.stroke();
            ctx.setLineDash([]);

            ctx.restore();
        }
    };

    return <Bar ref={chartRef} data={data} options={optionsChart} plugins={[verticalLinePlugin]} />;
};

export default GraficBarraHoritzontal;
